// AUTO-GENERATED GraphQL Builder for Bank
import * as Builders from '../';
export class BankBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  name(){ return this.add('name'); }
  code(){ return this.add('code'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  vendorList(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorList'))return this;
    this.v.add('vendorList');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorList { ${inner} }`);
    return this;
  }

  reverseVendor(b?:(q:Builders.VendorBuilder)=>void){
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorList { ${inner} }`);
    return this;
  }
}
